import { render, staticRenderFns } from "./CardSaldoUser.vue?vue&type=template&id=6fbb399c&scoped=true&"
import script from "./CardSaldoUser.vue?vue&type=script&lang=js&"
export * from "./CardSaldoUser.vue?vue&type=script&lang=js&"
import style0 from "./CardSaldoUser.vue?vue&type=style&index=0&id=6fbb399c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb399c",
  null
  
)

export default component.exports